import buildOptimizedAssetPath from '../../core/buildOptimizedAssetPath';

export const CoinIcon = () => (
  <img
    src={buildOptimizedAssetPath('images/built-coin', ['avif', 'png'])}
    alt="Coin"
    className="w-6 h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8"
  />
);
